import { createContext } from 'react';
import {DomainList } from "data/live/domain"

export const DomainContext = createContext(Object.values(DomainList)[0]);